export const croPerfomanceAnalyticsTableHeader = [
  /* {
    field: 'slNo',
    headerName: 'Sl No',
    width: 80,
    sortable: false,
    align: 'center',
    headerAlign: 'center',
  }, */
  {
    field: 'name',
    headerName: 'CRO',
    width: 140,
    sortable: true,
  },
  {
    field: 'active_students_from_date',
    headerName: 'Active Students (From Date)',
    width: 250,
    sortable: true,
  },
  {
    field: 'paying_students',
    headerName: 'Paying Students',
    width: 180,
    sortable: true,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'active_tutors_from_date',
    headerName: 'Active Tutors (From Date)',
    width: 250,
    sortable: true,
  },
  {
    field: 'student_tutor_ratio',
    headerName: 'Student Tutor Ratio',
    width: 180,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'revenue',
    headerName: 'Revenue',
    width: 140,
    sortable: true,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'arpu',
    headerName: 'ARPU',
    width: 120,
    sortable: true,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'arppu',
    headerName: 'ARPPU',
    width: 120,
    sortable: true,
    align: 'right',
    headerAlign: 'right',
  },
  {
    field: 'total_tp',
    headerName: 'Total TP',
    width: 120,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'sessions_held',
    headerName: 'Sessions Held',
    width: 150,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'average_tp',
    headerName: 'Average TP',
    width: 140,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'paying_student_rate',
    headerName: 'Paying Student Rate',
    width: 220,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'tc_uploaded',
    headerName: 'TC Uploads',
    width: 130,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'temp_inactive_to_active',
    headerName: 'Reactivations',
    width: 150,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'temp_inactive_to_inactive',
    headerName: 'TCs from Inactive',
    width: 180,
    sortable: true,
    align: 'center',
    headerAlign: 'center',
  },
];
